import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Card } from "antd";
import ConfettiExplosion from "react-confetti-explosion";
import bg from './auth_bg.png';
const BillingSuccess: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-no-repeat bg-cover" style={{
      backgroundImage: `url('${bg}')`, // <-- add your image path
    }}>
      <Card
        className="shadow-lg p-6 rounded-lg bg-white"
        style={{ maxWidth: 400, textAlign: 'center' }}
      >
        <CheckCircleOutlined
          style={{ fontSize: '64px', color: '#52c41a' }}
          className="mb-4"
        />
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Payment Successful!
        </h1>
        <div className='flex justify-center items-center'>

          <ConfettiExplosion
            force={0.8}
            duration={3000}
            particleCount={250}
            width={1600}
          />
        </div>
        <p className="text-gray-600 mb-6">
          Thank you for your purchase. Your payment has been processed successfully.
        </p>
        <Button
          key={'login'}
          href={'/login'}
          className="bg-primaryColor hover:bg-[#a390f1] px-8 py-2 rounded-md  text-white"
        >
          Login to your account
        </Button>
      </Card>
    </div>
  );
};

export default BillingSuccess;
